import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { ProfileService } from 'src/app/services/profile/profile.service';
import { requestClassificationInterface } from 'src/app/util/interfaces/requestClassification';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { RequestClassificationService } from './service/request-classification.service';
import { ClassificationService } from 'src/app/page/register-page/register-forms/classification/classification/service/classification.service';
import { LabelsInterface } from 'src/app/util/services/labels/data/label.inteface';

@Component({
	selector: 'pcp-request-classification',
	templateUrl: './request-classification.component.html',
	styleUrls: ['./request-classification.component.scss'],
})
export class RequestClassificationComponent implements OnInit {
	@Input()
	labels: LabelsInterface = {
		lbl_chamado_tipo_servico: '',
		lbl_geral_competencia: '',
		lbl_asset_category: '',
		lbl_geral_topico: '',
		lbl_geral_grupo: '',
		lbl_rep_tipo_change: '',
		lbl_geral_selecione: '',
		lbl_classificacao_selecionada_inativa: '',
		lbl_geral_severidade: '',
	};

	@Output()
	getClassification = new EventEmitter();

	constructor(
		private RequestClassificationService: RequestClassificationService,
		private LabelsService: LabelsService,
		private ProfileService: ProfileService,
		private NotificationService: NotificationService,
		private ClassificationService: ClassificationService
	) {}

	isLoadingLabels = true;
	isLoadingServiceType = false;
	isLoadingScope = false;
	isLoadingCategory = false;
	isLoadingTopic = false;
	isLoadingSolutionArea = false;
	isLoadingSeverity = false;
	isLoadingAnalysts = false;
	isLoadingChangeType = false;

	isClassificationComplete = false;

	// @Input()
	// public options = {
	//   isEditingClassification : true,
	//   disabled : false,
	//   customerList : null,
	//   lockField : [],
	//   hideField : [],
	//   alertField : [],
	//   initOn : "serviceType",
	//   onMe : false,
	//   hideServiceType : [],
	//   idCmdb: '',
	// }

	cascateOptions = ['solutionArea', 'serviceType', 'scope', 'category', 'topic', 'severity', 'changeType'];
	cascateLevel = -1;
	@Input()
	initialIdSolutionArea: string;
	@Input()
	initialIdServicetype: string;
	@Input()
	initialIdScope: string;
	@Input()
	initialIdCategory: string;
	@Input()
	initialIdTopic: string;
	@Input()
	initialIdSeverity: string;

	@Input()
	isEditingClassification = true;
	@Input()
	disabled = false;
	@Input()
	customerList = null;
	@Input()
	lockField = [];
	@Input()
	hideField = [];
	@Input()
	alertField = [];
	@Input()
	initOn = 'solutionArea';
	@Input()
	hideServiceType = [];
	@Input()
	onMe = false;
	@Input()
	idCmdb = '';
	@Input()
	requiredField = [];
	//On classification change, make this true if you don't want to erase the classification under
	@Input()
	keepClassification = false;

	availableClassification: requestClassificationInterface = {
		serviceType: [],
		scope: [],
		category: [],
		topic: [],
		solutionArea: [],
		analysts: [],
		impact: [],
		urgency: [],
		severity: [],
		changeType: [],
	};

	selectedClassification: requestClassificationInterface = {
		serviceType: [],
		scope: [],
		category: [],
		topic: [],
		solutionArea: [],
		analysts: [],
		impact: [],
		urgency: [],
		severity: [],
		changeType: [],
	};

	ngOnInit(): void {
		this.LabelsService.getLabels().subscribe((labels) => {
			this.labels = labels;
			this.isLoadingLabels = false;
		});

		this.cascateLevel = this.cascateOptions.indexOf(this.initOn);
		this.cascateLevel === -1 ? (this.cascateLevel = 0) : null;
		this.cascateInit();
	}

	setServiceType(idServiceType: string) {
		this.isClassificationComplete = false;

		this.alertField = [];

		this.selectedClassification = {
			serviceType: [],
			scope: [],
			category: [],
			topic: [],
			solutionArea: [],
			impact: [],
			urgency: [],
			severity: [],
			analysts: [],
			changeType: [],
		};

		this.availableClassification.scope = [];
		this.availableClassification.category = [];
		this.availableClassification.topic = [];
		this.availableClassification.solutionArea = [];
		this.availableClassification.analysts = [];
		this.availableClassification.changeType = [];

		for (let index = 0; index < this.availableClassification.serviceType.length; index++) {
			if (idServiceType != this.availableClassification.serviceType[index].id) continue;
			this.selectedClassification.serviceType[0] = this.availableClassification.serviceType[index];
			break;
		}

		this.isLoadingScope = true;
		this.RequestClassificationService.getScope(
			idServiceType,
			this.customerList ? this.customerList : this.ProfileService.userData().idCustomer,
			this.idCmdb,
			this.onMe == true ? this.ProfileService.userData().idAnalyst : null
		).subscribe(
			(scopes) => {
				this.availableClassification.scope = scopes;
				this.isLoadingScope = false;
				this.emitClassification();
			},
			() => {
				this.availableClassification.scope = [];
				this.isLoadingScope = false;
				this.NotificationService.setNotificationMessage(this.labels.lbl_classificacao_selecionada_inativa);
				this.emitClassification();
			}
		);
	}

	setScope(idScope: string): void {
		this.isClassificationComplete = false;

		this.alertField = [];

		this.selectedClassification.scope = [];
		this.selectedClassification.category = [];
		this.selectedClassification.topic = [];
		this.selectedClassification.solutionArea = [];
		this.selectedClassification.analysts = [];
		this.selectedClassification.severity = [];
		this.selectedClassification.changeType = [];

		this.availableClassification.category = [];
		this.availableClassification.topic = [];
		this.availableClassification.solutionArea = [];
		this.availableClassification.analysts = [];
		this.availableClassification.severity = [];
		this.availableClassification.changeType = [];

		for (let index = 0; index < this.availableClassification.scope.length; index++) {
			if (idScope != this.availableClassification.scope[index].id) continue;
			this.selectedClassification.scope[0] = this.availableClassification.scope[index];
			break;
		}

		this.isLoadingCategory = true;
		this.RequestClassificationService.getCategory(
			this.selectedClassification.serviceType[0].id,
			idScope,
			this.customerList ? this.customerList : this.ProfileService.userData().idCustomer,
			this.onMe == true ? this.ProfileService.userData().idAnalyst : null
		).subscribe(
			(categories) => {
				this.availableClassification.category = categories;
				this.isLoadingCategory = false;
				this.emitClassification();
			},
			() => {
				this.availableClassification.category = [];
				this.isLoadingCategory = false;
				this.NotificationService.setNotificationMessage(this.labels.lbl_classificacao_selecionada_inativa);
				this.emitClassification();
			}
		);
	}

	setCategory(idCategory: string): void {
		this.isClassificationComplete = false;

		this.alertField = [];

		this.selectedClassification.category = [];
		this.selectedClassification.topic = [];
		this.selectedClassification.solutionArea = [];
		this.selectedClassification.severity = [];
		this.selectedClassification.analysts = [];
		this.selectedClassification.changeType = [];

		this.availableClassification.topic = [];
		this.availableClassification.solutionArea = [];
		this.availableClassification.severity = [];
		this.availableClassification.analysts = [];
		this.availableClassification.changeType = [];

		for (let index = 0; index < this.availableClassification.category.length; index++) {
			if (idCategory != this.availableClassification.category[index].id) continue;
			this.selectedClassification.category[0] = this.availableClassification.category[index];
			break;
		}

		this.isLoadingTopic = true;
		this.RequestClassificationService.getTopic(
			this.selectedClassification.serviceType[0].id,
			idCategory,
			this.customerList ? this.customerList : this.ProfileService.userData().idCustomer,
			this.onMe == true ? this.ProfileService.userData().idAnalyst : null
		).subscribe(
			(topics) => {
				this.availableClassification.topic = topics;
				this.isLoadingTopic = false;
				this.emitClassification();
			},
			() => {
				this.availableClassification.topic = [];
				this.isLoadingTopic = false;
				this.NotificationService.setNotificationMessage(this.labels.lbl_classificacao_selecionada_inativa);
				this.emitClassification();
			}
		);
	}

	setTopic(idTopic: string): void {
		this.isClassificationComplete = false;

		this.alertField = [];

		this.selectedClassification.topic = [];
		this.selectedClassification.solutionArea = [];
		this.selectedClassification.severity = [];
		this.selectedClassification.analysts = [];
		this.selectedClassification.changeType = [];

		this.availableClassification.solutionArea = [];
		this.availableClassification.severity = [];
		this.availableClassification.analysts = [];
		this.availableClassification.changeType = [];

		for (let index = 0; index < this.availableClassification.topic.length; index++) {
			if (idTopic != this.availableClassification.topic[index].id) continue;
			this.selectedClassification.topic[0] = this.availableClassification.topic[index];
			break;
		}

		this.isLoadingSolutionArea = true;
		this.RequestClassificationService.getSolutionArea(
			this.selectedClassification.serviceType[0].id,
			idTopic,
			this.customerList ? this.customerList : this.ProfileService.userData().idCustomer,
			this.onMe == true ? this.ProfileService.userData().idAnalyst : null
		).subscribe(
			(solutionAreas) => {
				this.availableClassification.solutionArea = solutionAreas;
				this.isLoadingSolutionArea = false;
				this.emitClassification();
			},
			() => {
				this.availableClassification.solutionArea = [];
				this.isLoadingSolutionArea = false;
				this.NotificationService.setNotificationMessage(this.labels.lbl_classificacao_selecionada_inativa);
				this.emitClassification();
			}
		);
	}

	setSolutionArea(idSolutionArea: string): void {
		this.isClassificationComplete = false;

		this.alertField = [];

		this.selectedClassification.solutionArea = [];
		this.selectedClassification.analysts = [];
		this.selectedClassification.severity = [];
		this.selectedClassification.changeType = [];

		this.availableClassification.severity = [];
		this.availableClassification.analysts = [];
		this.availableClassification.changeType = [];

		for (let index = 0; index < this.availableClassification.solutionArea.length; index++) {
			if (idSolutionArea != this.availableClassification.solutionArea[index].id) continue;
			this.selectedClassification.solutionArea[0] = this.availableClassification.solutionArea[index];
			break;
		}

		/*this.isLoadingAnalysts = true;
    this.RequestClassificationService.getAnalystList(this.selectedClassification.solutionArea[0].id).subscribe(analysts => {
      this.isLoadingAnalysts = false;
      this.availableClassification.analysts = analysts;
      this.emitClassification();
    })*/

		this.isLoadingSeverity = true;
		this.RequestClassificationService.getSeverity(
			this.selectedClassification.serviceType[0].id,
			this.selectedClassification.topic[0].id,
			this.customerList ? this.customerList : this.ProfileService.userData().idCustomer,
			this.onMe == true ? this.ProfileService.userData().idAnalyst : null
		).subscribe(
			(severities) => {
				this.availableClassification.severity = severities;
				this.isLoadingSeverity = false;
				this.emitClassification();

				//Se for change, tem uma etapa a mais
				if (this.selectedClassification.serviceType[0].id === '3') {
					this.isLoadingChangeType = true;
					this.RequestClassificationService.getChangeType().subscribe((changeTypes) => {
						this.availableClassification.changeType = changeTypes;
						this.isLoadingChangeType = false;
						this.emitClassification();
					});
				}
			},
			() => {
				this.availableClassification.severity = [];
				this.isLoadingSeverity = false;
				this.NotificationService.setNotificationMessage(this.labels.lbl_classificacao_selecionada_inativa);
				this.emitClassification();
			}
		);
	}

	setSeverity(idSeverity: string): void {
		this.alertField = [];

		this.selectedClassification.severity = [];

		for (let index = 0; index < this.availableClassification.severity.length; index++) {
			if (idSeverity != this.availableClassification.severity[index].id) continue;
			this.selectedClassification.severity[0] = this.availableClassification.severity[index];
			break;
		}

		this.emitClassification();
		this.isClassificationComplete = true;
	}

	setChangeType(idChangeType: string): void {
		this.isClassificationComplete = false;

		this.alertField = [];

		this.selectedClassification.changeType = [];

		for (let index = 0; index < this.availableClassification.changeType.length; index++) {
			if (idChangeType != this.availableClassification.changeType[index].id) continue;
			this.selectedClassification.changeType[0] = this.availableClassification.changeType[index];
			break;
		}

		this.isClassificationComplete = true;
	}

	emitClassification(): void {
		this.getClassification.emit(JSON.stringify(this.selectedClassification));
	}

	cascateInit(): void {
		this.isLoadingServiceType = true;

		//Always get service type, it will never be empty
		this.ClassificationService.getClassificationServiceType().subscribe((serviceTypes) => {
			this.availableClassification.serviceType = serviceTypes;

			this.isLoadingServiceType = false;

			//SET SERVICE TYPE, GET SCOPE
			if (
				this.cascateLevel >= 0 &&
				this.initialIdServicetype != undefined &&
				this.initialIdServicetype != '-1' &&
				this.initialIdServicetype.toString().trim() != ''
			) {
				this.isLoadingScope = true;
				for (let index = 0; index < this.availableClassification.serviceType.length; index++) {
					if (this.availableClassification.serviceType[index].id != this.initialIdServicetype) continue;

					this.selectedClassification.serviceType[0] = this.availableClassification.serviceType[index];

					this.RequestClassificationService.getScope(
						this.initialIdServicetype,
						this.customerList ? this.customerList : this.ProfileService.userData().idCustomer,
						this.onMe == true ? this.ProfileService.userData().idAnalyst : null
					).subscribe((scopes) => {
						this.availableClassification.scope = scopes;
						this.isLoadingScope = false;

						//SET SCOPE, GET CATEGORY
						if (this.cascateLevel >= 1 && this.initialIdScope != undefined && this.initialIdScope != '-1') {
							this.isLoadingCategory = true;
							for (let index = 0; index < this.availableClassification.scope.length; index++) {
								if (this.availableClassification.scope[index].id != this.initialIdScope) continue;

								this.selectedClassification.scope[0] = this.availableClassification.scope[index];
								this.RequestClassificationService.getCategory(
									this.selectedClassification.serviceType[0].id,
									this.initialIdScope,
									this.customerList ? this.customerList : this.ProfileService.userData().idCustomer,
									this.onMe == true ? this.ProfileService.userData().idAnalyst : null
								).subscribe((categories) => {
									this.availableClassification.category = categories;
									this.isLoadingCategory = false;

									//SET CATEGORY, GET TOPIC
									if (this.cascateLevel >= 2 && this.initialIdCategory != undefined && this.initialIdCategory != '-1') {
										this.isLoadingTopic = true;
										for (let index = 0; index < this.availableClassification.category.length; index++) {
											if (this.availableClassification.category[index].id != this.initialIdCategory) continue;

											this.selectedClassification.category[0] = this.availableClassification.category[index];
											this.RequestClassificationService.getTopic(
												this.selectedClassification.serviceType[0].id,
												this.initialIdCategory,
												this.customerList ? this.customerList : this.ProfileService.userData().idCustomer,
												this.onMe == true ? this.ProfileService.userData().idAnalyst : null
											).subscribe((topics) => {
												this.availableClassification.topic = topics;
												this.isLoadingTopic = false;

												//SET TOPIC, GET SOLUTION AREA
												if (
													this.cascateLevel >= 3 &&
													this.initialIdTopic != undefined &&
													this.initialIdTopic != '-1'
												) {
													this.isLoadingSolutionArea = true;
													for (let index = 0; index < this.availableClassification.topic.length; index++) {
														if (this.availableClassification.topic[index].id != this.initialIdTopic) continue;

														this.selectedClassification.topic[0] = this.availableClassification.topic[index];

														this.RequestClassificationService.getSolutionArea(
															this.selectedClassification.serviceType[0].id,
															this.initialIdTopic,
															this.customerList
																? this.customerList
																: this.ProfileService.userData().idCustomer,
															this.onMe == true ? this.ProfileService.userData().idAnalyst : null
														).subscribe((solutionArea) => {
															this.availableClassification.solutionArea = solutionArea;
															this.isLoadingSolutionArea = false;

															//SET SOLUTION AREA
															if (this.cascateLevel >= 4) {
																for (
																	let index = 0;
																	index < this.availableClassification.solutionArea.length;
																	index++
																) {
																	if (
																		this.availableClassification.solutionArea[index].id !=
																		this.initialIdSolutionArea
																	)
																		continue;
																	this.selectedClassification.solutionArea[0] =
																		this.availableClassification.solutionArea[index];
																}
															}
														});

														//SET SEVERITY
														this.RequestClassificationService.getSeverity(
															this.selectedClassification.serviceType[0].id,
															this.selectedClassification.topic[0].id,
															this.customerList
																? this.customerList
																: this.ProfileService.userData().idCustomer,
															this.onMe == true ? this.ProfileService.userData().idAnalyst : null
														).subscribe((severities) => {
															this.availableClassification.severity = severities;
															this.isLoadingSeverity = false;

															if (this.cascateLevel >= 5) {
																for (
																	let index = 0;
																	index < this.availableClassification.severity.length;
																	index++
																) {
																	if (
																		this.availableClassification.severity[index].id !=
																		this.initialIdSeverity
																	)
																		continue;
																	this.selectedClassification.severity[0] =
																		this.availableClassification.severity[index];
																}
															}
														});
														break;
													}
												}
											});
											break;
										}
									}
								});
								break;
							}
						}
					});
					break;
				}
			}
		});
	}
}
